import {useState} from 'react';
import {useNavigate, useParams} from 'react-router';
import PageShell from '../components/PageShell';
import StripeCheckout from '../components/StripeCheckout';
import {confirmMembership} from '../api/AccountApi';
import {useAuth} from '../hooks/AuthContext';
import useIdempotencyKeys from '../hooks/useIdempotencyKeys';

export const checkoutStorageKey = (id) => `aidb.checkout.${id}`;

/** Pays for a membership plan started on the Membership page. */
export default function MembershipCheckout() {
  const {paymentId} = useParams();
  const navigate = useNavigate();
  const auth = useAuth();
  const keys = useIdempotencyKeys();
  const [done, setDone] = useState(false);
  let checkout = null;
  try {
    checkout = JSON.parse(sessionStorage.getItem(checkoutStorageKey(paymentId)) || 'null');
  } catch {
    checkout = null;
  }

  const onPaid = async () => {
    const status = await keys.run('membership-confirm', {paymentId}, (idempotencyKey) =>
      confirmMembership(paymentId, {idempotencyKey}),
    );
    if (!status.paid) throw new Error('Payment is still processing. Please check again shortly.');
    sessionStorage.removeItem(checkoutStorageKey(paymentId));
    await auth.getAccountData();
    setDone(true);
  };

  return (
    <PageShell title="Membership checkout" showBackButton={true}>
      <div className="container py-3" style={{maxWidth: 480}}>
        {done ? (
          <div role="status">
            <h2>Thank you!</h2>
            <p>Your membership has been upgraded.</p>
            <button type="button" className="btn btn-primary" onClick={() => navigate('/membership')}>
              Back to membership
            </button>
          </div>
        ) : checkout ? (
          <StripeCheckout
            clientSecret={checkout.client_secret}
            publishableKey={checkout.publishable_key}
            amountCents={checkout.amount_cents}
            onPaid={onPaid}
          />
        ) : (
          <p role="alert">This checkout session has expired. Please choose a plan again.</p>
        )}
      </div>
    </PageShell>
  );
}
